import { render, staticRenderFns } from "./FreeShiftEditorDialog.vue?vue&type=template&id=94cf2e3c&scoped=true&lang=pug&"
import script from "./FreeShiftEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./FreeShiftEditorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf2e3c",
  null
  
)

export default component.exports